import {
    VIEW_CHANGE_EMAIL,
    VIEW_CREATE_ACCOUNT,
    VIEW_DELETE_ACCOUNT,
    VIEW_EDIT_PROFILE,
    VIEW_FORGOT_PASSWORD,
    VIEW_LOGIN
} from '../constants/accountModalConstants';
const defaultView = VIEW_CREATE_ACCOUNT;

export const CHANGE_VIEW = 'CHANGE_VIEW';
export const CHANGE_VISIBLE_STATE = 'CHANGE_VISIBLE_STATE';
export const CHANGE_VISIBLE_STATE_MENU = 'CHANGE_VISIBLE_STATE_MENU';

export const changeView = (view) => ({
    type: CHANGE_VIEW,
    view: view,
    open: true
});

export const openChangeEmail = () => changeView(VIEW_CHANGE_EMAIL);
export const openDeleteAccount = () => changeView(VIEW_DELETE_ACCOUNT);
export const openEditProfile = () => changeView(VIEW_EDIT_PROFILE);
export const openCreateAccount = () => changeView(VIEW_CREATE_ACCOUNT);
export const openLogin = () => changeView(VIEW_LOGIN);
export const openForgotPassword = () => changeView(VIEW_FORGOT_PASSWORD);

export const open = (view = defaultView) => ({
    type: CHANGE_VISIBLE_STATE,
    open: true,
    view: view
});

export const close = () => ({
    type: CHANGE_VISIBLE_STATE,
    open: false
});

export const showAccountMenu = () => ({
    type: CHANGE_VISIBLE_STATE_MENU,
    open: true
});
export const hideAccountMenu = () => ({
    type: CHANGE_VISIBLE_STATE_MENU,
    open: false
});